var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"best-pick-pill",style:({
    color: _vm.sorting_options[_vm.value].color,
    background: _vm.sorting_options[_vm.value].background,
  })},[_c('span',{staticStyle:{"font-size":"50px","line-height":"0.1"}},[_vm._v(" · ")]),_c('span',{staticClass:"semibold"},[_vm._v("\n    "+_vm._s(_vm.sorting_options[_vm.value].description)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }